import { CreatePatientVisitInput, UpdatePatientVisitInput } from '@shared/services/gql.service';
import { decimalDivide } from '@shared/utils/floating-math';

import { ProtocolEntryGridRowWithOriginalIndex } from '../types/protocol-entry-grid-row';

const getDiscontinuationRate = (row: ProtocolEntryGridRowWithOriginalIndex): null | number => {
  return !row.optional && row.discontinuation_rate !== null
    ? decimalDivide(row.discontinuation_rate || 0, 100)
    : null;
};

export const getCreatePatientVisitParams = (
  rows: ProtocolEntryGridRowWithOriginalIndex[],
  protocolVersionId: string,
  patientGroup: null | string
): CreatePatientVisitInput[] => {
  return rows.map((row) => {
    return {
      discontinuation_rate: getDiscontinuationRate(row),
      optional: !!row.optional,
      order_by: row.originalIndex,
      patient_group_id: patientGroup,
      patient_protocol: {
        name: row.patient_protocol_name,
        patient_protocol_sub_type_id: row.patient_protocol_sub_type?.id || '',
        patient_protocol_version_id: protocolVersionId,
      },
      target_date_days_out: row.target_date_days_out || null,
      target_tolerance_days_out: row.target_tolerance_days_out || 0,
    };
  });
};

export const getUpdatePatientVisitParams = (
  rows: ProtocolEntryGridRowWithOriginalIndex[],
  protocolVersionId: string,
  hasOverallDiscontinuationRate: boolean,
  investigatorDiscontinuationRateFF: boolean
): UpdatePatientVisitInput[] => {
  return rows.map((row) => {
    const discontinuationRateParams: Pick<
      UpdatePatientVisitInput,
      'clear_discontinuation_rate' | 'discontinuation_rate'
    > = {};

    if (!hasOverallDiscontinuationRate && investigatorDiscontinuationRateFF) {
      const discontinuationRate = getDiscontinuationRate(row);

      discontinuationRateParams.clear_discontinuation_rate = discontinuationRate === null;
      discontinuationRateParams.discontinuation_rate = discontinuationRate;
    }

    return {
      ...discontinuationRateParams,
      optional: !!row.optional,
      order_by: row.originalIndex,
      patient_group_id: row.patient_group_id || null,
      patient_protocol: {
        id: row.patient_protocol_id,
        name: row.patient_protocol_name,
        patient_protocol_sub_type_id: row.patient_protocol_sub_type?.id || '',
        patient_protocol_version_id: protocolVersionId,
      },
      target_date_days_out: row.target_date_days_out || null,
      target_tolerance_days_out: row.target_tolerance_days_out || 0,
    };
  });
};
